export default "__VITE_ASSET__Cj$6AQCc__"